import { render, staticRenderFns } from "./AIAssistantModal.vue?vue&type=template&id=9824e3b8&scoped=true&"
import script from "./AIAssistantModal.vue?vue&type=script&lang=js&"
export * from "./AIAssistantModal.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistantModal.vue?vue&type=style&index=0&id=9824e3b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9824e3b8",
  null
  
)

export default component.exports